import { useController } from 'react-hook-form';
import { RadioGroup } from 'ui/radioGroup/radioGroup';
import { Props as RadioGroupProps } from 'ui/radioGroup/types';
import { FieldProps } from './types';

type RadioGroupFieldProps = FieldProps & Omit<RadioGroupProps, 'value'>;

export const RadioGroupField = ({ name, onSelect, ...rest }: RadioGroupFieldProps) => {
  const {
    field: { onChange, value },
  } = useController({
    name,
    defaultValue: '',
  });

  const onSelectHandler = (value: any) => {
    if (onSelect && typeof onSelect === 'function') {
      onSelect(value);
    } else {
      onChange(value);
    }
  };

  return <RadioGroup {...rest} name={name} value={value} onSelect={onSelectHandler} />;
};
